import api from "../../utils/api";

const baseEndpoint = process.env.REACT_APP_API_BASE_URL
  ? process.env.REACT_APP_API_BASE_URL
  : "";
export const baseAPI = api(baseEndpoint);

const statementService = {
  statement: async () => {
    return baseAPI.post(`/Mobile/SelfService/DowloadStatement`);
  },
  requestStatement: async (payload: any) => {
    return baseAPI.post(`/Mobile/SelfService/StatementRequestDate`, payload);
  },
  requestThirdPartyStatement: async (payload: any) => {
    // const query = new URLSearchParams(payload).toString();
    return baseAPI.post(`/v2/SelfServices/thirdpartystatementrequest`, payload);
  },
};
export default statementService;
